import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import AuthenticationService from './AuthenticationService.js'

class WelcomeComponent extends Component {

    constructor(props) {
        super(props)
        this.state = { hora: new Date() }
    }

    componentDidMount() {
        this.props.setUserLoggedIn(AuthenticationService.getLoggedInUserName())
        this.timer = setInterval(() => this.setState({ hora: new Date() }), 1000)
    }

    componentWillUnmount() {
        clearInterval(this.timer)
    }

    getGreeting() {
        const h = this.state.hora.getHours()
        if (h < 12) return 'Buenos días'
        if (h < 19) return 'Buenas tardes'
        return 'Buenas noches'
    }

    formatDate(date) {
        return date.toLocaleDateString('es-MX', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
    }

    formatTime(date) {
        return date.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
    }

    render() {
        const userName = AuthenticationService.getLoggedInUserName()
        const { hora } = this.state

        const modules = [
            { perm: "READ_ALERTAS",         to: "/alertas",          label: "Alertas",          icon: "🔔", desc: "Pendientes y avisos", color: "#f59e0b" },
            { perm: "READ_SOCIEDADES",       to: "/sociedades",       label: "Sociedades",       icon: "🏢", desc: "Gestión de sociedades", color: "#3b82f6" },
            { perm: "READ_CLIENTES",         to: "/clientes",         label: "Proyectos",        icon: "📁", desc: "Clientes y proyectos", color: "#8b5cf6" },
            { perm: "READ_DOMICILIOS",       to: "/domicilios",       label: "Domicilios",       icon: "📍", desc: "Registro de domicilios", color: "#10b981" },
            { perm: "READ_DOCUMENTOS",       to: "/documentos",       label: "Documentos",       icon: "📄", desc: "Gestión documental", color: "#6366f1" },
            { perm: "READ_PERSONAS_FISICAS", to: "/personas-fisicas", label: "Personas Físicas", icon: "👤", desc: "Registro de personas", color: "#ec4899" },
            { perm: "READ_CFDIS",            to: "/cfdis",            label: "CFDIs",            icon: "🧾", desc: "Facturas y comprobantes", color: "#14b8a6" },
            { perm: "READ_HISTORIA",         to: "/historial",        label: "Historial",        icon: "📋", desc: "Registro de actividad", color: "#f97316" },
            { perm: "READ_BUSQUEDA",         to: "/busqueda",         label: "Búsqueda",         icon: "🔍", desc: "Búsqueda general", color: "#64748b" },
            { perm: "READ_USUARIOS",         to: "/users",            label: "Usuarios",         icon: "👥", desc: "Administración de usuarios", color: "#a855f7" },
        ]

        const availableModules = modules.filter(m => AuthenticationService.haveAuthorization(m.perm))

        return (
            <div style={styles.root}>
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

                    @keyframes fadeInUp {
                        from { opacity: 0; transform: translateY(16px); }
                        to   { opacity: 1; transform: translateY(0); }
                    }
                    @keyframes fadeIn {
                        from { opacity: 0; }
                        to   { opacity: 1; }
                    }

                    .welcome-root * { font-family: 'Inter', sans-serif; box-sizing: border-box; }

                    .module-card {
                        background: white;
                        border: 1px solid #e8edf5;
                        border-radius: 16px;
                        padding: 24px 20px;
                        text-decoration: none;
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                        transition: all 0.2s;
                        animation: fadeInUp 0.5s ease forwards;
                        opacity: 0;
                        cursor: pointer;
                        position: relative;
                        overflow: hidden;
                    }
                    .module-card::before {
                        content: '';
                        position: absolute;
                        top: 0; left: 0; right: 0;
                        height: 3px;
                        background: var(--card-color);
                        border-radius: 16px 16px 0 0;
                    }
                    .module-card:hover {
                        transform: translateY(-4px);
                        box-shadow: 0 12px 32px rgba(0,0,0,0.1);
                        border-color: var(--card-color);
                    }
                    .module-icon {
                        width: 44px; height: 44px;
                        border-radius: 12px;
                        display: flex; align-items: center; justify-content: center;
                        font-size: 1.3rem;
                        background: var(--card-bg);
                    }
                    .module-label {
                        font-size: 0.9rem; font-weight: 700;
                        color: #1e293b;
                    }
                    .module-desc {
                        font-size: 0.75rem; color: #94a3b8;
                        font-weight: 400;
                    }
                    .module-arrow {
                        font-size: 0.8rem; color: #cbd5e1;
                        margin-top: auto;
                        transition: color 0.2s, transform 0.2s;
                    }
                    .module-card:hover .module-arrow {
                        color: var(--card-color);
                        transform: translateX(4px);
                    }
                `}</style>

                <div className="welcome-root" style={styles.inner}>

                    {/* Header bienvenida */}
                    <div style={styles.header}>
                        <div style={styles.headerLeft}>
                            <p style={styles.greeting}>{this.getGreeting()},</p>
                            <h1 style={styles.userName}>{userName} 👋</h1>
                            <p style={styles.date}>{this.formatDate(hora)}</p>
                        </div>
                        <div style={styles.clock}>
                            <span style={styles.clockTime}>{this.formatTime(hora)}</span>
                            <span style={styles.clockLabel}>Hora del sistema</span>
                        </div>
                    </div>

                    {/* Divider */}
                    <div style={styles.divider} />

                    {/* Módulos */}
                    <div style={styles.sectionHeader}>
                        <h2 style={styles.sectionTitle}>Módulos disponibles</h2>
                        <span style={styles.sectionCount}>{availableModules.length} accesos</span>
                    </div>

                    <div style={styles.grid}>
                        {availableModules.map((m, i) => (
                            <Link
                                key={m.to}
                                to={m.to}
                                className="module-card"
                                style={{
                                    '--card-color': m.color,
                                    '--card-bg': m.color + '18',
                                    animationDelay: `${i * 0.06}s`,
                                }}
                            >
                                <div className="module-icon">{m.icon}</div>
                                <div className="module-label">{m.label}</div>
                                <div className="module-desc">{m.desc}</div>
                                <div className="module-arrow">→</div>
                            </Link>
                        ))}
                    </div>

                    {/* Footer */}
                    <div style={styles.footer}>
                        <span>Cloud  Zenyth by KrvheD</span>
                        <span>·</span>
                        <span>© 2026</span>
                    </div>
                </div>
            </div>
        )
    }
}

const styles = {
    root: {
        minHeight: '100vh',
        background: '#f1f5f9',
        padding: '32px 28px',
        fontFamily: "'Inter', sans-serif",
    },
    inner: {
        maxWidth: 1100,
        margin: '0 auto',
    },
    header: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 16,
        animation: 'fadeIn 0.6s ease forwards',
    },
    headerLeft: {},
    greeting: {
        margin: '0 0 4px',
        fontSize: '0.9rem',
        color: '#64748b',
        fontWeight: 500,
    },
    userName: {
        margin: '0 0 6px',
        fontSize: '2rem',
        fontWeight: 700,
        color: '#0f172a',
    },
    date: {
        margin: 0,
        fontSize: '0.82rem',
        color: '#94a3b8',
        textTransform: 'capitalize',
    },
    clock: {
        background: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: 14,
        padding: '14px 22px',
        textAlign: 'right',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
    },
    clockTime: {
        display: 'block',
        fontSize: '1.5rem',
        fontWeight: 700,
        color: '#0f172a',
        letterSpacing: '1px',
        fontVariantNumeric: 'tabular-nums',
    },
    clockLabel: {
        fontSize: '0.68rem',
        color: '#94a3b8',
        letterSpacing: '1px',
        textTransform: 'uppercase',
    },
    divider: {
        height: 1,
        background: '#e2e8f0',
        margin: '28px 0',
    },
    sectionHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 20,
    },
    sectionTitle: {
        margin: 0,
        fontSize: '1rem',
        fontWeight: 700,
        color: '#1e293b',
    },
    sectionCount: {
        fontSize: '0.78rem',
        color: '#94a3b8',
        background: '#f1f5f9',
        border: '1px solid #e2e8f0',
        borderRadius: 20,
        padding: '3px 12px',
        fontWeight: 500,
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
        gap: 16,
    },
    footer: {
        display: 'flex',
        gap: 8,
        justifyContent: 'center',
        marginTop: 40,
        fontSize: '0.72rem',
        color: '#cbd5e1',
    },
}

export default WelcomeComponent
